module.exports = __webpack_public_path__ + "img/Cuba.bd8a980b.gif";